import React from 'react';

type FieldLabelProps = {
  htmlFor: string;
  children: React.ReactNode;
};

// Sits above the control without taking layout space, as grow-ui's form label
// did; the surrounding forms reserve that room with their own top margins.
export const FieldLabel = ({ htmlFor, children }: FieldLabelProps) => (
  <div className="flex">
    <label
      htmlFor={htmlFor}
      className="text-neutral-600 text-sm antialiased inline-flex items-center align-middle absolute -mt-6"
    >
      {children}
    </label>
  </div>
);

type FieldMessageProps = {
  message?: string | null;
};

// Absolutely positioned so a message appearing never reflows the form. The
// kit's controls already carry a 2px bottom margin, so a 2px top margin puts
// the text 4px below the border, as grow-ui's was.
export const FieldMessage = ({ message }: FieldMessageProps) => (
  <div
    aria-live="polite"
    title={message ?? undefined}
    className={`absolute text-red-600 text-xs mt-2px mb-1 mr-2 whitespace-nowrap truncate ${
      message ? 'visible' : 'invisible'
    }`}
  >
    {message || ' '}
  </div>
);
